//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SliderInput',
  props: {
    id: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: 'Slider input',
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
    min: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
    },
  },
  methods: {
    getErrors() {
      const errors = [];
      if (!this.$v.value.required) {
        errors.push(`${this.name} is required`);
      }
      return errors;
    },
  },
  mounted() {
    console.log(this.max, this.min);
  },
};
